import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-with-us',
  templateUrl: './chat-with-us.component.html',
  styleUrls: ['./chat-with-us.component.css']
})
export class ChatWithUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
